import React from 'react';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { FirebaseProvider } from '../context/Firebase';
import { getFlavorConfig } from '../shared/config/flavorConfig';

type AppProvidersProps = {
  children: React.ReactNode;
};

const AppProviders = ({ children }: AppProvidersProps) => {
  const shouldUseHashRouter = process.env.REACT_APP_ROUTER_MODE !== 'browser';
  const RouterComponent = shouldUseHashRouter ? HashRouter : BrowserRouter;

  const flavor = getFlavorConfig();
  const theme = createTheme({
    palette: {
      primary: {
        main: flavor.theme.accent,
        dark: flavor.theme.accentDark,
        light: flavor.theme.activeBg,
      },
      secondary: {
        main: flavor.theme.activeText,
      },
      background: {
        default: flavor.theme.bodyBg,
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <RouterComponent>
        <FirebaseProvider>{children}</FirebaseProvider>
      </RouterComponent>
    </ThemeProvider>
  );
};

export default AppProviders;
